const SALESMAN_TOKEN_KEY = 'san_gao_salesman_token';
const SALESMAN_MODE_KEY = 'san_gao_salesman_mode';

// 入口参数只控制页面流程；账号归属、免验证码权限仍由后端校验。
export function isTaikangSalesmanMode(query) {
  return !!query && String(query.taikang) === '1';
}

export function isTaikangSalesmanSession() {
  return !!localStorage.getItem(SALESMAN_TOKEN_KEY)
    && localStorage.getItem(SALESMAN_MODE_KEY) === 'taikang';
}

export function getSanGaoSalesmanSessionOrgId() {
  try {
    const info = JSON.parse(localStorage.getItem('san_gao_salesman_info') || 'null');
    if (info && info.orgId) return String(info.orgId);
  } catch (error) {
    // 旧缓存异常时回退到独立机构缓存，不影响重新登录。
  }
  return localStorage.getItem('san_gao_salesman_orgId') || '';
}

export function clearSanGaoSalesmanSession() {
  [
    SALESMAN_TOKEN_KEY,
    SALESMAN_MODE_KEY,
    'san_gao_salesman_info',
    'san_gao_org_info',
    'san_gao_salesman_code',
    'san_gao_salesman_pending_pay',
  ].forEach(key => localStorage.removeItem(key));
}
